/**
 * @file editHandoff.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-19
 * @modified 2026-10-19
 * @description Edit a document from a view window or another screen (Cam, 19
 *              Oct 2026: "add the edit button to the view modals for SOs POs
 *              Bills etc. as well as view invoice modal"). The same hand-off
 *              each search screen's Edit already uses: the id in sessionStorage
 *              under the editor's own key, then on to the editor, which reads it
 *              on mount (CreateInvoice, CreateCustomerOrder, CreatePurchaseOrder,
 *              CreateBill).
 *
 *              When that editor is already the open screen, navigating to it
 *              changes nothing, so the hand-off would wait unread: EDIT_EVENT
 *              tells Dashboard to mount it afresh.
 */

export const EDIT_EVENT = 'excel-edit-handoff';

const TARGETS = {
  invoice: { key: 'editInvoiceId', menu: 'create-invoice' },
  credit_note: { key: 'editInvoiceId', menu: 'create-credit-note' },
  customer_order: { key: 'editOrderId', menu: 'create-customer-order' },
  purchase_order: { key: 'editPOId', menu: 'create-purchase-order' },
  bill: { key: 'editBillId', menu: 'create-bill' }
};

/** Can a document of this type be handed to an editor? */
export const editable = (type) => !!TARGETS[type];

/**
 * Open the editor for one document. `navigate` is the shell's
 * navigateToMenu(menu). Returns false when there is nothing to do it with.
 * @param {'invoice'|'credit_note'|'customer_order'|'purchase_order'|'bill'} type
 * @param {string|number} id  the editor's id: db id, but a PO's Xero id (TEMP-/LOCAL- included)
 */
export function startEdit(type, id, navigate) {
  const target = TARGETS[type];
  if (!target || id === null || id === undefined || id === '' || typeof navigate !== 'function') return false;
  try { sessionStorage.setItem(target.key, String(id)); } catch (e) { return false; }
  window.dispatchEvent(new CustomEvent(EDIT_EVENT, { detail: { menu: target.menu } }));
  navigate(target.menu);
  return true;
}
